// // src/hooks/fetch-hooks/get-indent-transfer/get-indent-transfer.js

// import { useQuery } from "react-query";
// import { request } from "../../../config/helpers/axios-instance";

// const GetIndentTransfer = (quotationId) => {
//     const USE_MOCK_DATA = true; // Set to false to use real API

//     return useQuery(
//         ["get-indent-transfer", quotationId],
//         () => {
//             if (USE_MOCK_DATA) {
//                 // Mock API response
//                 return new Promise((resolve) => {
//                     setTimeout(() => {
//                         resolve({
//                             data: {
//                                 success: true,
//                                 data: {
//                                     indentDetails: [
//                                         {
//                                             quotationId: 160,
//                                             indentNo: "ISRQ-100026000007",
//                                             status: "SENT",
//                                             items: [
//                                                 {
//                                                     itemId: 88,
//                                                     quantity: 10,
//                                                     lineItemRemarks: "Item Short: MDRGD16000066"
//                                                 }
//                                             ],
//                                             createdAt: "2026-02-09T07:04:22.763Z"
//                                         }
//                                     ]
//                                 },
//                                 error: ""
//                             }
//                         });
//                     }, 800);
//                 });
//             } else {
//                 return request({
//                     url: `/hinai/userorder/indentTransfer/${quotationId}`,
//                     method: "GET",
//                 });
//             }
//         },
//         {
//             enabled: !!quotationId,
//             refetchOnWindowFocus: false,
//         }
//     );
// };

// convert it to the r
import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { TENANT_COMPANY_MAP } from "../../../utils/constants";
import { getTenantId } from "../../../utils/helpers";

const GetIndentTransfer = (quotationId) => {

    const tenantId = getTenantId();
    const isEasydose = process.env.REACT_APP_EASYDOSE_FEATURE_ENABLED === 'true' && tenantId === TENANT_COMPANY_MAP.EAZY;
    
    return useQuery(
        ["get-indent-transfer", quotationId],
        () => request({ url: `/hinai/userorder/getIndentDetails/${quotationId}`, method: "GET" }),
        {
            enabled: isEasydose && !!quotationId,   // <— only Easydose fires
            refetchOnWindowFocus: false,
        }
    );
};

export default GetIndentTransfer;